import React from 'react';
import { ArrowRightIcon, BookOpenIcon, ClockIcon, LanguagesIcon, MonitorSmartphoneIcon, PrinterIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton, PRICE, PRODUCT_SPEC, SUPPORT_EMAIL, Section } from './Shared';
import { Bellflower, Blossom, Daisy, DropperBottle } from './FloralDecor';
const inclusions = [{
  icon: BookOpenIcon,
  text: 'Materiali digitali'
}, {
  icon: LanguagesIcon,
  text: 'Italiano'
}, {
  icon: MonitorSmartphoneIcon,
  text: 'Consultazione su più dispositivi'
}, {
  icon: PrinterIcon,
  text: 'Stampabile'
}];
export function Pricing() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-247" data-mp="25ry4pi5tkku6">
      <Section id="buy" className="rounded-xl border border-stone-200 bg-amber-50/60" data-id="element-248" data-mp="25q4ujsvzzihf">
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden rounded-xl" data-id="element-249" data-mp="20rtl3j9m79zq">
          <Blossom className="absolute left-6 top-8 h-20 w-20" petalClassName="text-pink-200" centerClassName="text-amber-300" data-id="element-250" data-mp="3h9hejtdwnm1p" />
          <Daisy className="absolute right-10 top-10 hidden h-14 w-14 md:block" petalClassName="text-white" centerClassName="text-amber-400" data-id="element-251" data-mp="3vzp5xj5hic9j" />
          <Bellflower className="absolute bottom-0 left-4 hidden h-40 w-20 md:block" petalClassName="text-violet-300/70" centerClassName="text-emerald-300/70" data-id="element-252" data-mp="4rugf94nzu5c" />
          <DropperBottle className="absolute bottom-6 right-8 hidden h-32 w-16 text-amber-700/20 md:block" data-id="element-253" data-mp="er1yg9mcgcys" />
        </div>

        <div className="relative mx-auto mb-10 max-w-2xl text-center" data-id="element-254" data-mp="3da0fo3ckvk0i">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-500 px-3 py-1 text-xs font-bold tracking-wide text-emerald-950" data-id="element-255" data-mp="3i7sgxnz44ihd">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-256" data-mp="3n5kaemfeocno" />
            OFFERTA DI LANCIO
          </span>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-257" data-mp="3rz6f9sfbvc8x">
            Il kit completo a 20 €
          </h2>
          <p className="mt-4 text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-258" data-mp="2zh0ylwx5dhqu">
            Un unico acquisto per avere i due volumi, tutti i bonus e la mappa dei 38 rimedi.
          </p>
          <p className="mt-1 text-base font-semibold text-emerald-800 md:text-lg" data-id="element-259" data-mp="2mi1j9cr3tp9c">Tutto incluso. Nessun abbonamento.</p>
        </div>

        <div className="relative mx-auto max-w-2xl" data-id="element-260" data-mp="315cx5lardlcm">
          <div className="rounded-xl border-2 border-amber-500 bg-white p-6 shadow-md md:p-8" data-id="element-261" data-mp="2w7l3omugtr6b">
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-262" data-mp="28i0n2alsb607">
              <div className="max-w-sm" data-id="element-263" data-mp="28k39kknqah06">
                <p className="text-xs font-semibold tracking-widest text-amber-800" data-id="element-264" data-mp="23jfhrwrodw4w">LA TUA BIBLIOTECA COMPLETA</p>
                <h3 className="mt-1 text-lg font-bold text-emerald-900 md:text-xl" data-id="element-265" data-mp="2ih7xoq14wmjm">KIT COMPLETO FIORI DI BACH™</h3>
                <p className="mt-1.5 text-sm font-medium text-stone-700" data-id="element-266" data-mp="2dgajeoj8wcne">{PRODUCT_SPEC}</p>
                <p className="mt-1 text-sm text-stone-500" data-id="element-267" data-mp="3tuab5c7xsvzk">
                  188 pagine tra contenuti pratici e strumenti di consultazione.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-268" data-mp="a453vntx2r1">
                <p className="text-xs font-semibold tracking-widest text-stone-500" data-id="element-269" data-mp="cglw5hup72i">PREZZO DI LANCIO</p>
                <p className="text-4xl font-bold tracking-tight text-emerald-700 md:text-5xl" data-id="element-270" data-mp="57dtd7zhf8da">{PRICE}</p>
                <p className="mt-1 text-xs text-stone-500" data-id="element-271" data-mp="3nhfza1njrwoa">Tutto il kit in formato PDF.</p>
              </div>
            </div>

            <p className="mt-6 border-t border-stone-200 pt-6 text-sm leading-relaxed text-stone-700" data-id="element-272" data-mp="j0d6j3bskqho">
              Ascolto, confronto dei rimedi, combinazioni da personalizzare, uso topico, registrazione, cura
              dell’operatore e organizzazione dell’attività.
            </p>

            <CTAButton fullWidth className="mt-7 gap-2 px-6 py-5 text-base md:text-xl" data-id="element-273" data-mp="e9wtvlfsp8wd">
              VOGLIO IL KIT COMPLETO A 20 €
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-274" data-mp="11yob5hruk6ud" />
            </CTAButton>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-275" data-mp="16r93eev3ubvs">
              {inclusions.map(({
              icon: Icon,
              text
            }) => <li key={text} className="flex items-center gap-1.5 text-xs text-stone-700 md:text-sm" data-id="element-276" data-mp="3a85yhpadctmi">
                  <Icon className="h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-277" data-mp="358kpsn5ed6wl" />
                  {text}
                </li>)}
            </ul>
          </div>

          <div id="refund-policy" className="mt-6 flex scroll-mt-20 gap-4 rounded-lg bg-emerald-50 p-5" data-id="element-278" data-mp="1sm76vt9dla3">
            <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-279" data-mp="3sz6vw8vuch3y" />
            <div data-id="element-280" data-mp="3o7ymvdyfaxrb">
              <h3 className="font-bold text-emerald-900" data-id="element-281" data-mp="3o7f27phe1v9l">Politica di rimborso di 7 giorni</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-stone-700" data-id="element-282" data-mp="3k7eq4bhrhw5p">
                Se desideri richiedere un rimborso, scrivici entro 7 giorni di calendario dalla data di acquisto a{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="font-medium text-rose-700 transition-colors duration-150 ease-out hover:text-rose-800" data-id="element-283" data-mp="fs54suog1e85">
                  {SUPPORT_EMAIL}
                </a>{' '}
                indicando i dati dell’ordine, e segui le indicazioni della nostra Politica di rimborso.
              </p>
              <p className="mt-2 text-sm leading-relaxed text-stone-700" data-id="element-284" data-mp="27e9xhdbig392">
                Questa politica volontaria non limita i diritti dei consumatori che non possono essere esclusi in base
                alle leggi applicabili nel tuo paese.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}